var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { DrivingMarketMsgIcon } from "@domains/features/Markets/Equity/entities/iDrivingMarket";
import { ECallPutTabs, EOptionDrivingMarketSectionType, } from "@domains/features/Markets/Options/entites/drivingMarket";
import { msgCreater } from "@domains/features/Markets/Options/utils/messgesCreater";
import { EmptyValidation } from "@domains/utils/commonText";
import { symbolUpdate } from "@domains/utils/symbolList";
import { streamKeys } from "@adapters/repositories/stream/QuoteResponseMappper";
import { STREAMING_TYPE } from "@adapters/repositories/stream/IQuoteStreamRepo";
import { StreamingSectionName } from "@adapters/repositories/stream/QuoteStreamRepo";
var OptionDrivingMarketManager = /** @class */ (function () {
    function OptionDrivingMarketManager(usecase, actions, useCasesStream) {
        var _a;
        this.usecase = usecase;
        this.actions = actions;
        this.useCasesStream = useCasesStream;
        this.symbols = (_a = {},
            _a[EOptionDrivingMarketSectionType.HIGHEST_OI] = [],
            _a[EOptionDrivingMarketSectionType.HIGHEST_OI_GAINER] = [],
            _a[EOptionDrivingMarketSectionType.HIGHEST_OI_LOSER] = [],
            _a[EOptionDrivingMarketSectionType.HIGHEST_VOLUME] = [],
            _a);
        this.allSymbols = [];
        this.streamMapKey = [
            streamKeys[0],
            streamKeys[1],
            streamKeys[2],
            streamKeys[3],
            streamKeys[4],
            streamKeys[6],
            streamKeys[7],
            streamKeys[8],
            streamKeys[9],
        ];
        this.clearMsg = function (type, reducerName, sectionAction) {
            sectionAction.removeTabsMsg(type, reducerName);
        };
    }
    OptionDrivingMarketManager.prototype.drivingMarketSymbolUpdate = function (data, type) {
        var _this = this;
        data.call
            .slice(0, 5)
            .map(function (x) { return symbolUpdate(x.symbol, type, _this.symbols, _this.allSymbols); });
        data.put
            .slice(0, 5)
            .map(function (x) { return symbolUpdate(x.symbol, type, _this.symbols, _this.allSymbols); });
    };
    OptionDrivingMarketManager.prototype.streamDataUpdate = function (mappedData) {
        var _this = this;
        var updateKey = Object.entries(this.symbols).map(function (_a) {
            var _b = __read(_a, 2), keys = _b[0], values = _b[1];
            if (values.includes(mappedData.symbol)) {
                return keys;
            }
        });
        updateKey
            .filter(function (x) { return x; })
            .map(function (key) {
            switch (key) {
                case EOptionDrivingMarketSectionType.HIGHEST_OI:
                    {
                        _this.actions.highestOI.streamUpdate(mappedData, key);
                    }
                    break;
                case EOptionDrivingMarketSectionType.HIGHEST_OI_GAINER:
                    _this.actions.highestOIGainer.streamUpdate(mappedData, key);
                    break;
                case EOptionDrivingMarketSectionType.HIGHEST_OI_LOSER:
                    _this.actions.highestOILosers.streamUpdate(mappedData, key);
                    break;
                case EOptionDrivingMarketSectionType.HIGHEST_VOLUME:
                    _this.actions.highestVolumeGroth.streamUpdate(mappedData, key);
                    break;
                default:
            }
        });
    };
    OptionDrivingMarketManager.prototype.drivingMarketStream = function (subscribe, symbols, sectionName) {
        var _this = this;
        this.useCasesStream.streamQuote(STREAMING_TYPE.MINIQUOTE, subscribe, function (mappedData) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.allSymbols.includes(mappedData.symbol)) {
                    this.streamDataUpdate(mappedData);
                }
                return [2 /*return*/];
            });
        }); }, symbols, this.streamMapKey, sectionName);
    };
    OptionDrivingMarketManager.prototype.getHighestOIData = function (req) {
        var _this = this;
        this.clearMsg(ECallPutTabs.CALL, EOptionDrivingMarketSectionType.HIGHEST_OI, this.actions.highestOI);
        this.clearMsg(ECallPutTabs.PUT, EOptionDrivingMarketSectionType.HIGHEST_OI, this.actions.highestOI);
        this.actions.highestOI.hideError(EOptionDrivingMarketSectionType.HIGHEST_OI);
        this.actions.highestOI.setParams(req, EOptionDrivingMarketSectionType.HIGHEST_OI);
        this.actions.highestOI.loader(EOptionDrivingMarketSectionType.HIGHEST_OI);
        this.usecase.highestOI.execute({
            onSuccess: function (data) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(data.call && data.put)) return [3 /*break*/, 3];
                            return [4 /*yield*/, this.handleMsg(data.call.length, EOptionDrivingMarketSectionType.HIGHEST_OI, this.actions.highestOI, ECallPutTabs.CALL)];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, this.handleMsg(data.put.length, EOptionDrivingMarketSectionType.HIGHEST_OI, this.actions.highestOI, ECallPutTabs.PUT)];
                        case 2:
                            _a.sent();
                            this.drivingMarketSymbolUpdate(data, EOptionDrivingMarketSectionType.HIGHEST_OI);
                            this.actions.highestOI.getHighestOIData(data, EOptionDrivingMarketSectionType.HIGHEST_OI);
                            _a.label = 3;
                        case 3:
                            this.actions.highestOI.stopLoader(EOptionDrivingMarketSectionType.HIGHEST_OI);
                            return [2 /*return*/];
                    }
                });
            }); },
            onError: function (error) {
                _this.actions.highestOI.setError({ isOpen: true, error: error }, EOptionDrivingMarketSectionType.HIGHEST_OI);
                _this.actions.highestOI.stopLoader(EOptionDrivingMarketSectionType.HIGHEST_OI);
            },
        }, req);
    };
    OptionDrivingMarketManager.prototype.getHighestGainerData = function (req) {
        var _this = this;
        req.type = "gain";
        this.clearMsg(ECallPutTabs.CALL, EOptionDrivingMarketSectionType.HIGHEST_OI_GAINER, this.actions.highestOIGainer);
        this.clearMsg(ECallPutTabs.PUT, EOptionDrivingMarketSectionType.HIGHEST_OI_GAINER, this.actions.highestOIGainer);
        this.actions.highestOIGainer.hideError(EOptionDrivingMarketSectionType.HIGHEST_OI_GAINER);
        this.actions.highestOI.setParams(req, EOptionDrivingMarketSectionType.HIGHEST_OI_GAINER);
        this.actions.highestOIGainer.loader(EOptionDrivingMarketSectionType.HIGHEST_OI_GAINER);
        this.usecase.highestOIGainer.execute({
            onSuccess: function (data) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!data) return [3 /*break*/, 3];
                            return [4 /*yield*/, this.handleMsg(data.call.length, EOptionDrivingMarketSectionType.HIGHEST_OI_GAINER, this.actions.highestOIGainer, ECallPutTabs.CALL)];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, this.handleMsg(data.put.length, EOptionDrivingMarketSectionType.HIGHEST_OI_GAINER, this.actions.highestOIGainer, ECallPutTabs.PUT)];
                        case 2:
                            _a.sent();
                            this.drivingMarketSymbolUpdate(data, EOptionDrivingMarketSectionType.HIGHEST_OI_GAINER);
                            this.actions.highestOIGainer.getHighestGainerData(data, EOptionDrivingMarketSectionType.HIGHEST_OI_GAINER);
                            _a.label = 3;
                        case 3:
                            this.actions.highestOIGainer.stopLoader(EOptionDrivingMarketSectionType.HIGHEST_OI_GAINER);
                            return [2 /*return*/];
                    }
                });
            }); },
            onError: function (error) {
                _this.actions.highestOIGainer.setError({ isOpen: true, error: error }, EOptionDrivingMarketSectionType.HIGHEST_OI_GAINER);
                _this.actions.highestOIGainer.stopLoader(EOptionDrivingMarketSectionType.HIGHEST_OI_GAINER);
            },
        }, req);
    };
    OptionDrivingMarketManager.prototype.getHighestLoseerData = function (req) {
        var _this = this;
        req.type = "loss";
        this.clearMsg(ECallPutTabs.CALL, EOptionDrivingMarketSectionType.HIGHEST_OI_LOSER, this.actions.highestOILosers);
        this.clearMsg(ECallPutTabs.PUT, EOptionDrivingMarketSectionType.HIGHEST_OI_LOSER, this.actions.highestOILosers);
        this.actions.highestOILosers.hideError(EOptionDrivingMarketSectionType.HIGHEST_OI_LOSER);
        this.actions.highestOILosers.loader(EOptionDrivingMarketSectionType.HIGHEST_OI_LOSER);
        this.actions.highestOI.setParams(req, EOptionDrivingMarketSectionType.HIGHEST_OI_LOSER);
        this.usecase.highestOILosers.execute({
            onSuccess: function (data) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!data) return [3 /*break*/, 3];
                            return [4 /*yield*/, this.handleMsg(data.call.length, EOptionDrivingMarketSectionType.HIGHEST_OI_LOSER, this.actions.highestOILosers, ECallPutTabs.CALL)];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, this.handleMsg(data.put.length, EOptionDrivingMarketSectionType.HIGHEST_OI_LOSER, this.actions.highestOILosers, ECallPutTabs.PUT)];
                        case 2:
                            _a.sent();
                            this.drivingMarketSymbolUpdate(data, EOptionDrivingMarketSectionType.HIGHEST_OI_LOSER);
                            this.actions.highestOILosers.getHighestLosersData(data, EOptionDrivingMarketSectionType.HIGHEST_OI_LOSER);
                            _a.label = 3;
                        case 3:
                            this.actions.highestOILosers.stopLoader(EOptionDrivingMarketSectionType.HIGHEST_OI_LOSER);
                            return [2 /*return*/];
                    }
                });
            }); },
            onError: function (error) {
                _this.actions.highestOILosers.setError({ isOpen: true, error: error }, EOptionDrivingMarketSectionType.HIGHEST_OI_LOSER);
                _this.actions.highestOILosers.stopLoader(EOptionDrivingMarketSectionType.HIGHEST_OI_LOSER);
            },
        }, req);
    };
    OptionDrivingMarketManager.prototype.getHighestVolumeData = function (req) {
        var _this = this;
        this.clearMsg(ECallPutTabs.CALL, EOptionDrivingMarketSectionType.HIGHEST_OI_LOSER, this.actions.highestVolumeGroth);
        this.clearMsg(ECallPutTabs.PUT, EOptionDrivingMarketSectionType.HIGHEST_OI_LOSER, this.actions.highestVolumeGroth);
        this.actions.highestVolumeGroth.hideError(EOptionDrivingMarketSectionType.HIGHEST_VOLUME);
        this.actions.highestVolumeGroth.loader(EOptionDrivingMarketSectionType.HIGHEST_VOLUME);
        this.actions.highestOI.setParams(req, EOptionDrivingMarketSectionType.HIGHEST_VOLUME);
        this.usecase.highestVolumeGroth.execute({
            onSuccess: function (data) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!data) return [3 /*break*/, 3];
                            return [4 /*yield*/, this.handleMsg(data.call.length, EOptionDrivingMarketSectionType.HIGHEST_VOLUME, this.actions.highestVolumeGroth, ECallPutTabs.CALL)];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, this.handleMsg(data.put.length, EOptionDrivingMarketSectionType.HIGHEST_VOLUME, this.actions.highestVolumeGroth, ECallPutTabs.PUT)];
                        case 2:
                            _a.sent();
                            this.drivingMarketSymbolUpdate(data, EOptionDrivingMarketSectionType.HIGHEST_VOLUME);
                            this.actions.highestVolumeGroth.getHighestVolumeData(data, EOptionDrivingMarketSectionType.HIGHEST_VOLUME);
                            _a.label = 3;
                        case 3:
                            this.actions.highestVolumeGroth.stopLoader(EOptionDrivingMarketSectionType.HIGHEST_VOLUME);
                            return [2 /*return*/];
                    }
                });
            }); },
            onError: function (error) {
                _this.actions.highestVolumeGroth.setError({ isOpen: true, error: error }, EOptionDrivingMarketSectionType.HIGHEST_VOLUME);
                _this.actions.highestVolumeGroth.stopLoader(EOptionDrivingMarketSectionType.HIGHEST_VOLUME);
            },
        }, req);
    };
    OptionDrivingMarketManager.prototype.handleMsg = function (value, sectionType, sectionAction, callPutTypes) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (value === 0) {
                    sectionAction.setTabsMsg(sectionType, callPutTypes, {
                        msg: EmptyValidation.default,
                        show: true,
                        icon: DrivingMarketMsgIcon.DEFAULT,
                    });
                }
                else if (value < 5) {
                    sectionAction.setTabsMsg(sectionType, callPutTypes, {
                        msg: msgCreater(value, sectionType),
                        show: true,
                        icon: DrivingMarketMsgIcon.LIMIT,
                    });
                }
                return [2 /*return*/];
            });
        });
    };
    OptionDrivingMarketManager.prototype.getAllData = function (req) {
        switch (req.dataType) {
            case EOptionDrivingMarketSectionType.HIGHEST_OI:
                return this.getHighestOIData(req);
            case EOptionDrivingMarketSectionType.HIGHEST_OI_GAINER:
                return this.getHighestGainerData(req);
            case EOptionDrivingMarketSectionType.HIGHEST_OI_LOSER:
                return this.getHighestLoseerData(req);
            case EOptionDrivingMarketSectionType.HIGHEST_VOLUME:
                return this.getHighestVolumeData(req);
            default:
                this.getHighestLoseerData(req);
                this.getHighestVolumeData(req);
                this.getHighestOIData(req);
                this.getHighestGainerData(req);
        }
    };
    OptionDrivingMarketManager.prototype.optionDrivingMarketStreamViewAll = function (subscribe, symbols, callBack) {
        var streamMapKey = [
            streamKeys[0],
            streamKeys[1],
            streamKeys[2],
            streamKeys[3],
            streamKeys[4],
            streamKeys[6],
            streamKeys[7],
            streamKeys[8],
            streamKeys[9],
        ];
        this.useCasesStream.streamQuote(STREAMING_TYPE.MINIQUOTE, subscribe, callBack, symbols, streamMapKey, StreamingSectionName.OP_DrivingMarket_ViewAll);
    };
    return OptionDrivingMarketManager;
}());
export default OptionDrivingMarketManager;
